import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const resourceEntitlementStyle: moduleStyleType = {
    box: {
        mt: '12px',
        mb: '20px',
    },
    description: {
        marginLeft: 5,
    },
}
